// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"314":"f0500580","678":"75c8a9df"}[chunkId] + ".chunk.css";
};